module.exports = __webpack_public_path__ + "static/media/ehealthpro_mini_assistant_slider_phone1.d781775b.png";